<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel" width="800">
      <h3 slot="header" class="modal-header">录入交割信息</h3>
      <!--<table-list title="" :columns="columns" :data="data"-->
      <!--:loading="loading2" :total="total" :current="current"-->
      <!--@change-page="changePage"></table-list>-->

      <Row class="row">
        <Col span="3">房间号</Col>
        <Col span="3">项目类别</Col>
        <Col span="3">是否智能</Col>
        <Col span="3">付费模式</Col>
        <Col span="3">底数</Col>
        <Col span="3">附件</Col>
        <Col span="3">备注</Col>
        <Col span="3">物品配置</Col>
      </Row>

      <Row class="row" v-for="(item,index) in dataCopy" :key="'keyA'+index">
        <Form :model="item" :inline="true" :rules="formRules" :ref="'form'+index">
          <Col span="3">房间号</Col>
          <Col span="3">项目类别</Col>
          <Col span="3">是否智能</Col>
          <Col span="3">付费模式</Col>
          <Col span="3">
            <span v-if="data[index].shishu">{{item.shishu}}</span>
            <span v-else>
              <FormItem prop="shishu" class="notip">
                 <Input class="inputwidth" v-model="item.shishu"/>
              </FormItem>
          </span>

          </Col>
          <Col span="3">
            <span v-if="data[index].shishu">{{item.fujian}}</span>
            <Upload v-else
                    :action="baseUrl+'/file/uploadFile'"
                    :data="{index:index}"
                    :on-success="handleSuccess"
                    :headers="{'Access-Token':token}"
                    :show-upload-list="false"
                    :on-error="handleError"
                    :format="['jpg','jpeg','png']"
                    :on-format-error="formatError"
            >
              <a>{{item.fujian || '上传'}}</a>
            </Upload>
          </Col>
          <Col span="3">备注</Col>
          <Col span="3">物品配置</Col>
        </Form>
      </Row>

      <div style="margin-bottom: 50px">
        <Page :total="total" size="small" :current="current" show-total transfer @on-change="changePage"
              class="mt20 fr"></Page>
      </div>
      <goods-detail :n="goodsN"></goods-detail>
    </Modal>


  </div>

</template>

<script>
  import GoodsDetail from './GoodsDetail'
  import TableList from "components/TableList/index";
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";

  export default {
    name: "DeliveryInputBusin", //企业录入交割
    components: {
      TableList,
      GoodsDetail
    },
    props: {
      n: {
        type: Number,
        default: 0
      },

    },
    watch: {
      n() {
        this.isShow = true
      }
    },
    data() {
      return {
        formRules: {
          shishu: [
            {required: true, trigger: 'blur', validator: this.validateNumber2}

          ]

        },

        token: '',
        baseUrl: '',
        goodsN: 0,
        loading: true,
        isShow: false,
        current: 1,
        total: 0,
        loading2: false,
        columns: [
          {
            title: "房间号",
            // width: 130,
            key: "",
            align: "center"
          },
          {
            title: "项目类别",
            // width: 130,
            key: "",
            align: "center"
          },
          {
            title: "是否智能",
            // width: 130,
            key: "",
            align: "center"
          },
          {
            title: "付费模式",  //欢乐谷项目支持修改，其他不可以
            // width: 130,
            key: "",
            align: "center"
          },
          {
            title: "底数",
            // width: 130,
            key: "",
            align: "center"
          },
          {
            title: "附件",
            // width: 130,
            key: "",
            align: "center",
            render: (h, params) => {
              return h('')

            }
          },
          {
            title: "备注",
            // width: 130,
            key: "",
            align: "center"
          },
          {
            title: "物品配置",
            // width: 130,
            key: "",
            align: "center",
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    this.goodsN++
                  }
                }
              }, '详情')
            }
          },
        ],
        data: [{test: 1, shishu: 1, fujian: '1.jpg'}, {test: 2, shishu: null}, {test: 2, shishu: null}],
        dataCopy: [{test: 1, shishu: 1, fujian: '1.jpg'}, {test: 2, shishu: null}, {test: 2, shishu: null}]
      }
    },
    methods: {
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      validateNumber2(rule, value, callback) {
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error());
        }
        callback();
      },
      formatError() {
        this.$Message.info('请上传图片类型文件')
      },
      changePage() {

      },
      ok() {
        var validated = true
        for (let i in this.$refs) {
          this.$refs[i][0] && this.$refs[i][0].validate(bool => {
            bool == false && (validated = false)
          })
        }
        if (!validated) {
          this.changeLoading()
          return
        }
      },
      cancel() {
      },
      handleError() {
      },
      handleSuccess() {
        // console.log(arguments)
      }
    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }
  }
</script>

<style scoped>
  .inputwidth {
    width: 70px;
  }

  .ivu-form-item {
    margin-bottom: 0;
  }

  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;

    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

</style>
